import { IListItem } from '@tencent/semi-ui/esm/components/list-selector/Item';
import { redirectIOA } from 'common/compositions/RedirectIOA';
import { CAPTCHA_CANCEL, CAPTCHA_ERROR, MOBILE_SAFE_ERR_CODE } from 'common/constants/Constants';
import i18n from 'common/locales';
import { ILoginAccount } from 'idpBase/api/type';
import {
  LOGIN_REACH_API_EVENT,
  LOGIN_VERIFY_TYPE,
  PAGE_TYPE,
  SUBMIT_RESULT,
} from 'idpBase/Constants';
import { AuthnApi } from 'idpBase/http';
import { TGlobalStore, TUpdateStore } from 'idpBase/store';
import { createCaptchaReport } from 'idpBase/utils';
import { LOGIN_ACCOUNT_ERROR_MSG } from './constant';

export type TItem = ILoginAccount & IListItem;

class LoginStore {
  readonly global: TGlobalStore;
  updateStore: TUpdateStore<LoginStore>;
  resetStore: () => void;

  /** 手机号 */
  mobile: string;
  /** 邮箱 */
  email: string;
  /** 页面栈，记录页面跳转历史 */
  pageStack: PAGE_TYPE[] = [];
  /** 登录企业列表 */
  accounts: Array<TItem> = [];
  /** 解绑企业列表 */
  unbindAccounts: Array<TItem> = [];
  /** 邀请加入的企业信息 */
  invitationAccount: ILoginAccount | null;
  /** 需要确认邮箱/手机号的企业信息，非空时展示确认弹窗 */
  handshakeConfirmAccount: ILoginAccount | null;
  /** 登录企业结果类型 */
  subType = '';

  /**
   * 上一个页面
   */
  get prePage() {
    return this.pageStack.at(-2);
  }

  /**
   * 当前页面
   */
  get currentPage() {
    return this.pageStack.at(-1);
  }

  /**
   * 页面入栈，并自动跳转到下一个页面
   * @param currentPage
   */
  goForward(currentPage: PAGE_TYPE) {
    this.pageStack.push(currentPage);
  }

  /**
   * 页面出栈，并自动跳转到上一个页面
   */
  goBack() {
    this.pageStack.pop();
  }

  /**
   * 登录企业
   */
  async loginAccount(accountId: string, reportVerifyType?: string, skipSelect?: string) {
    const reportParams = createCaptchaReport(
      this.global.rootStore.getReportGlobalParams(),
      LOGIN_VERIFY_TYPE.MOBILE_ACCOUNT_SELECT,
    );
    const loginRet = await AuthnApi.loginAccount(accountId, reportParams);
    reportVerifyType &&
      this.global.rootStore.dataReport(LOGIN_REACH_API_EVENT, {
        verify_type: reportVerifyType,
        submit_result: loginRet.errCode ? SUBMIT_RESULT.FAIL : SUBMIT_RESULT.SUCCESS,
        isSendBeacon: true,
      });
    if (loginRet.errCode) {
      const errMessage = i18n.t(
        LOGIN_ACCOUNT_ERROR_MSG[loginRet.errCode] || '登录失败，请稍后重试',
        {
          ns: 'idp',
        },
      );
      const isAccountUnSafe = [CAPTCHA_CANCEL, CAPTCHA_ERROR, MOBILE_SAFE_ERR_CODE].includes(
        loginRet.errCode,
      );
      this.global.rootStore.global.handleError(isAccountUnSafe ? loginRet : errMessage);
      return loginRet;
    }

    // 不确定这段老逻辑的作用，跟产品沟通，先保留
    if (redirectIOA(loginRet)) return loginRet;

    this.global.rootStore.redirectToLandingPage({ skipSelect });

    return loginRet;
  }
}

export default LoginStore;
